import LoopFront from "loop-front";

const CustomActivities = {
    TOGGLE_PUBLISH: 'publish'
}

export class Exercise extends LoopFront<{}, {},typeof CustomActivities> {
    constructor() {
        super('exercises', {}, {}, CustomActivities);
    }
}

export const OExercise = new Exercise();